import { Skeleton } from "@/components/ui/skeleton";

const FundingSkeleton = () => {
  return (
    <div className="mt-5 bg-[#F7F9FB] rounded-[20px] p-5">
      <Skeleton className=" w-[200px] h-5 mb-5 bg-[#ecedee]" />
      <div className="flex  gap-5 mt-5 pl-5 py-5">
        <div className="mr-8">
          <Skeleton className="h-[20px] mb-2 w-[100px] h-7 rounded-[5px] bg-[#ecedee]" />
          <Skeleton className="h-[20px] w-[100px] h-7 rounded-[5px] bg-[#ecedee]" />
        </div>
        <div className=" w-full flex flex-col gap-2 ml-10 mr-10">
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]" />
            ))}
          </div>
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]" />
            ))}
          </div>
        </div>
      </div>
      <div className="ml-5 mr-10">
        <Skeleton className="w-full rounded-sm h-36 bg-[#ecedee]" />
      </div>
    </div>
  );
};

export default FundingSkeleton;
